import { Injectable } from '@angular/core';
import { AccessibilitySourceCodeExcludeRepoService } from '@client/app/services/api/accessibility-source-code-exclude-repo.service';

@Injectable({
    providedIn: 'root',
})
export class AccessibilitySourceCodeExcludesService {

    constructor (
        private accessibilitySourceCodeExcludeRepoService: AccessibilitySourceCodeExcludeRepoService,
    ) { }

    update (sourceCodeExclude: any, updatedSourceCodeExclude: any, params?: any, config?: any): Promise<any> {
        return this.accessibilitySourceCodeExcludeRepoService.update(
            sourceCodeExclude,
            updatedSourceCodeExclude,
            params,
            config,
        );
    }

    create (sourceCodeExclude: any, params?: any, config?: any): Promise<any> {
        return this.accessibilitySourceCodeExcludeRepoService.create(sourceCodeExclude, params, config);
    }

    destroy (sourceCodeExclude: any, params?: any, config?: any): Promise<any> {
        return this.accessibilitySourceCodeExcludeRepoService.destroy(sourceCodeExclude.id, params, config);
    }
}
